import { render, staticRenderFns } from "./MainSkipToContentLink.vue?vue&type=template&id=7c2e6bf4&scoped=true&"
import script from "./MainSkipToContentLink.vue?vue&type=script&lang=js&"
export * from "./MainSkipToContentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e6bf4",
  null
  
)

export default component.exports